import Vue from 'vue';
import BigNumber from 'bignumber.js';
import { PercentType } from '@/components/pages/bonus/enums';
export default Vue.extend({
    name: 'loadLine',
    data: () => {
        return {
            typeIndex: 0
        };
    },
    props: {
        currentValue: {
            type: BigNumber,
            default: 0,
            required: true
        },
        type: {
            type: String,
            default: PercentType.progressive,
            required: false
        },
        scaleInfo: {
            type: Object,
            default: () => {
                return {
                    25: ['0', '2499.99'],
                    26: ['2500', '4999.99'],
                    27: ['5000', '9999.99'],
                    28: ['10000', '14999.99'],
                    29: ['15000', '29999.99'],
                    30: ['30000', '9999999999']
                };
            },
            required: false
        }
    },
    methods: {
        getRatio(el, idx) {
            const from = BigNumber(el[0]);
            const to = BigNumber(el[1]).isNaN() ? BigNumber(Infinity) : BigNumber(el[1]);
            const value = BigNumber(this.currentValue);
            if (value.lte(from))
                return 0;
            if (this.isFixed && idx > 0 && (value.gte(to) || from.eq(30000)))
                return 0;
            if (value.gte(to) || from.eq(30000))
                return 100;
            return Number(value.minus(from).div(to.minus(from)).multipliedBy(100));
        },
        getRangeToShow(value) {
            const val = BigNumber(value);
            const firstKeyPercent = Object.keys(this.scaleInfo)[0];
            const minValue = BigNumber(this.scaleInfo[firstKeyPercent][1]).div(1000).toString();
            return val.lte(0) ? `≤${minValue}K` : `${val.div(1000).toString()}K`;
        },
        fillColor(idx) {
            return this.isFixed && idx !== 0 ? '#5F2432' : '#292C35';
        }
    },
    computed: {
        getMinValue() {
            if (!Object.keys(this.scaleInfo)[0])
                return;
            const firstKeyPercent = Object.keys(this.scaleInfo)[0];
            return `${BigNumber(this.scaleInfo[firstKeyPercent][1]).div(1000).toString()}K`;
        },
        scale() {
            return Object.entries(this.scaleInfo);
        },
        isFixed() {
            return this.type === PercentType.fixed;
        }
    }
});
